import React from 'react'
import { useTranslation } from 'react-i18next'
import { UserCheck, AlertTriangle } from 'lucide-react'

interface StatusCardProps {
    title: string
    description: string
    icon: React.ReactNode
    borderColor: string
    criteria: string[]
}

const StatusCard: React.FC<StatusCardProps> = ({
    title,
    description,
    icon,
    borderColor,
    criteria,
}) => {
    return (
        <div
            className="bg-white rounded p-3 text-xs"
            style={{ borderLeft: `3px solid ${borderColor}` }}
        >
            <div className="flex items-center gap-2 mb-2">
                {icon}
                <div className="font-semibold text-gray-800">{title}</div>
            </div>
            <p className="text-gray-600 mb-2">{description}</p>
            <ul className="list-disc list-inside space-y-1 text-gray-600">
                {criteria.map((item, idx) => (
                    <li key={idx}>{item}</li>
                ))}
            </ul>
        </div>
    )
}

const AssignmentStatusLegend: React.FC<{ className?: string }> = ({
    className = '',
}) => {
    const { t } = useTranslation('marketing')

    return (
        <div className="p-2">
            <div className={`grid grid-cols-1 gap-3 ${className}`}>
                <StatusCard
                    title={t('assignment_status.unassigned_stale.title')}
                    description={t(
                        'assignment_status.unassigned_stale.description'
                    )}
                    icon={
                        <AlertTriangle size={16} className="text-orange-500" />
                    }
                    borderColor="#F59E0B"
                    criteria={[
                        t('assignment_status.unassigned_stale.criteria_1'),
                        t('assignment_status.unassigned_stale.criteria_2'),
                        t('assignment_status.unassigned_stale.criteria_3'),
                    ]}
                />
                <StatusCard
                    title={t('assignment_status.assigned.title')}
                    description={t('assignment_status.assigned.description')}
                    icon={<UserCheck size={16} className="text-green-500" />}
                    borderColor="#22C55E"
                    criteria={[
                        t('assignment_status.assigned.criteria_1'),
                        t('assignment_status.assigned.criteria_2'),
                    ]}
                />
            </div>
        </div>
    )
}

export default AssignmentStatusLegend
